import * as React from "react";
import { Box } from "@mui/material";
import PatientForm from "../forms/PatientForm";
import PatientCreateForm from "../components/PatientCreateForm";

export default function PatientsCreatePage() {
  return (
    <Box sx={{ p: 2 }}>
     <PatientCreateForm />
 
    </Box>
  );
}